export default __webpack_public_path__ + "static/media/icon-time.911beee3.svg";